import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { dateFormatMSPipe } from './dateMs.pipe';
import { SafePipe } from './safe.pipe';
import { PlacePipe } from './place.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [dateFormatMSPipe, SafePipe, PlacePipe],
  exports: [dateFormatMSPipe, SafePipe, PlacePipe],
})
export class SharedPipesModule {}
